import { render, staticRenderFns } from "./importdata-prk.vue?vue&type=template&id=6e92d8cf&scoped=true&"
import script from "./importdata-prk.vue?vue&type=script&lang=js&"
export * from "./importdata-prk.vue?vue&type=script&lang=js&"
import style0 from "./importdata-prk.vue?vue&type=style&index=0&id=6e92d8cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e92d8cf",
  null
  
)

export default component.exports